
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { Form } from 'view-design'
@Component
export default class LoginForm extends Vue {
    @Prop({
        default: () => [{ required: true, message: '密码不能为空', trigger: 'blur' }]
    })
    readonly passwordRules!: object | Array<any>
    @Prop({
        default: () => [{ required: true, message: '账号不能为空', trigger: 'blur' }]
    })
    readonly userNameRules!: object | Array<any>
    name: string = 'LoginForm'
    form = {
        userName: '',
        password: '',
        code: ''
    }
    // computed
    get rules() {
        return {
            userName: this.userNameRules,
            password: this.passwordRules
        }
    }

    @Emit('on-success-valid')
    submit() {
        return {
            userName: this.form.userName,
            password: this.form.password,
            code: this.form.code
        }
    }
    // method
    handleSubmit() {
        ;(this.$refs.loginForm as Form).validate((valid) => {
            if (valid) {
                this.submit()
            }
        })
    }

    created() {}
}
